import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { About } from 'views/about'

const AboutPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'about.meta.title' })}
        description={formatMessage({ id: 'about.meta.description' })}
      />
      <Header bordered={false} />
      <About />
      <Footer />
    </>
  )
}

export default AboutPage
